export const PUSH_REGISTRATION_ACTIVE_MARKER_KEY =
  "reelitpro.push.active.v1";
export const PUSH_REGISTRATION_OWNER_BINDING_KEY =
  "reelitpro.push.owner-binding.v1";

const ACTIVE_MARKER_VALUE = "1";

function getDefaultStorage() {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
}

function getDefaultCrypto() {
  try {
    return typeof window !== "undefined" ? window.crypto : null;
  } catch {
    return null;
  }
}

function getDefaultTextEncoder() {
  try {
    return typeof TextEncoder === "function" ? TextEncoder : null;
  } catch {
    return null;
  }
}

async function ownerBinding(accountKey, options = {}) {
  const normalized = typeof accountKey === "string" ? accountKey.trim() : "";
  const cryptoApi = options.cryptoApi ?? getDefaultCrypto();
  const TextEncoderClass = options.TextEncoderClass ?? getDefaultTextEncoder();
  if (!normalized || !cryptoApi?.subtle?.digest || !TextEncoderClass) return null;
  try {
    const digest = await cryptoApi.subtle.digest(
      "SHA-256",
      new TextEncoderClass().encode(normalized)
    );
    return Array.from(new Uint8Array(digest), (byte) =>
      byte.toString(16).padStart(2, "0")
    ).join("");
  } catch {
    return null;
  }
}

export function hasPushRegistrationCleanupIntent(
  storage = getDefaultStorage()
) {
  if (!storage) return false;
  try {
    return (
      storage.getItem(PUSH_REGISTRATION_ACTIVE_MARKER_KEY) ===
      ACTIVE_MARKER_VALUE
    );
  } catch {
    return false;
  }
}

export function hasPushRegistrationOwnerBinding(
  storage = getDefaultStorage()
) {
  if (!storage) return false;
  try {
    return /^[0-9a-f]{64}$/.test(
      storage.getItem(PUSH_REGISTRATION_OWNER_BINDING_KEY) || ""
    );
  } catch {
    return false;
  }
}

export async function setPushRegistrationOwnerBinding(
  accountKey,
  options = {}
) {
  const storage = options.storage ?? getDefaultStorage();
  if (!storage) return false;
  const binding = await ownerBinding(accountKey, options);
  if (!binding) return false;
  try {
    storage.setItem(PUSH_REGISTRATION_OWNER_BINDING_KEY, binding);
    return true;
  } catch {
    return false;
  }
}

export async function matchesPushRegistrationOwnerBinding(
  accountKey,
  options = {}
) {
  const storage = options.storage ?? getDefaultStorage();
  if (!storage) return false;
  const binding = await ownerBinding(accountKey, options);
  if (!binding) return false;
  try {
    return storage.getItem(PUSH_REGISTRATION_OWNER_BINDING_KEY) === binding;
  } catch {
    return false;
  }
}

export function clearPushRegistrationOwnerBinding(
  storage = getDefaultStorage()
) {
  if (!storage) return false;
  try {
    storage.removeItem(PUSH_REGISTRATION_OWNER_BINDING_KEY);
    return true;
  } catch {
    return false;
  }
}

export function setPushRegistrationCleanupIntent(
  storage = getDefaultStorage()
) {
  if (!storage) return false;
  try {
    storage.setItem(PUSH_REGISTRATION_ACTIVE_MARKER_KEY, ACTIVE_MARKER_VALUE);
    return true;
  } catch {
    return false;
  }
}

export function clearPushRegistrationCleanupIntent(
  storage = getDefaultStorage()
) {
  if (!storage) return false;
  try {
    storage.removeItem(PUSH_REGISTRATION_ACTIVE_MARKER_KEY);
    storage.removeItem(PUSH_REGISTRATION_OWNER_BINDING_KEY);
    return true;
  } catch {
    return false;
  }
}
